export default {
  usuario: {
    matricula: {
      value: '',
      maxlength: '70',
      required: false,
      state: null
    },
    name: {
      value: '',
      options: [],
      required: false,
      state: null
    },
    username: {
      value: '',
      maxlength: '70',
      required: true,
      state: null,
      disabled: false
    },
    email: {
      value: null,
      maxlength: '70',
      required: false,
      state: null
    },
    administrador: {
      value: null,
      options: [],
      required: true,
      state: null
    },
    permissoes: {
      value: null,
      options: [
        {name: 'Movimentação de Associados', value: 'MOVIMENTACAO'}
      ],
      required: false,
      state: null
    },
    currentPassword: {
      value: '',
      maxlength: '30',
      required: false,
      state: null
    },
    password: {
      value: '',
      maxlength: '30',
      required: false,
      state: null
    },
    confirmation: {
      value: '',
      maxlength: '30',
      required: false,
      state: null
    },
    mfaActive: {
      value: null,
      options: [],
      required: true,
      state: null
    }
  },
  cargoId: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  matricula: {
    value: '',
    maxlength: '20',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/employee/components/add/employee-form.js